import { useMutation } from "react-query";
import { upsertSleepProfile } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertSleepProfile = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertSleepProfile(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the sleep profile.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    upsertSleepProfileMutation: mutate,
    isUpsertSleepProfileLoading: isLoading,
    ...rest,
  };
};

export default useUpsertSleepProfile;
